import {Paper, Typography} from "@mui/material";
import {Container} from "@mui/system";
import Footer from "./Footer";
import React from "react";
import repairWork from "../../components/Icons/repair-work.webp";
import Box from "@mui/material/Box";
import {useParams} from "react-router-dom";

const RepairWork = () => {
    const {page} = useParams();
    return (
        <>
            <Paper sx={{
                width: '100%',
                height: '100%',
                paddingBottom: "40px",
                display: 'flex',
                justifyContent: "space-between",
                flexGrow: 1,
                alignItems: "center",
            }}>
                <Container sx={{
                    "&.MuiContainer-root": {
                        maxWidth: "1668px",
                        display: 'flex',
                        flexDirection: "column",
                        gridGap: "100px",
                    },
                }}>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: "40px",
                    }}>
                        <Box sx={{
                            height: '624px',
                            width: "659px",
                            borderRadius: "8px",
                            backgroundImage: `url(${repairWork})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                        }}/>
                        <Typography sx={{
                            fontSize: 40,
                            fontWeight: '700',
                            lineHeight: 1.2,
                            // color: (theme) => theme.palette.primary.dark,
                        }}>
                            {`Hа странице ${page || ""} ведутся технические работы`}
                        </Typography>
                    </Box>
                </Container>
            </Paper>
            <Footer></Footer>
        </>
    );
};

export default RepairWork;